export const CATEGORY_REQUEST = "CATEGORY_REQUEST";
export const CATEGORY_RECEIVE = "CATEGORY_RECEIVE";
export const CATEGORY_FAILURE = "CATEGORY_FAILURE";
export const RESET_CATEGORY = "RESET_CATEGORY";
